<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';

import KanbanColumn from './KanbanColumn.vue';

const props = defineProps({
  board: {
    type: Object,
    required: true,
  },
});

const store = useStore();
const { t } = useI18n();

const steps = computed(() => {
  const list = props.board.steps || [];
  const order = props.board.steps_order || [];
  if (!order.length) return list;
  const byId = new Map(list.map(s => [s.id, s]));
  const ordered = order.map(id => byId.get(id)).filter(Boolean);
  const leftover = list.filter(s => !order.includes(s.id));
  return [...ordered, ...leftover];
});

const tasksByStep = stepId =>
  store.getters['kanban/tasks/getTasksByStep'](stepId);

const handleTaskMoved = async ({ taskId, boardStepId }) => {
  try {
    await store.dispatch('kanban/tasks/move', {
      boardId: props.board.id,
      taskId,
      boardStepId,
    });
  } catch (error) {
    useAlert(t('KANBAN.ERRORS.MOVE_FAILED'));
  }
};
</script>

<template>
  <div class="flex gap-4 h-full overflow-x-auto p-4">
    <KanbanColumn
      v-for="step in steps"
      :key="step.id"
      :step="step"
      :tasks="tasksByStep(step.id)"
      @task-moved="handleTaskMoved"
    />
  </div>
</template>
